import React from 'react';
import ComponentHelper from '../../../../supers/ComponentHelper';
import '../dashboard-builder/dashboard-builder.css';
import RoutingService from '../../../../services/RoutingService';
import RESTService from '../../../../services/RESTService';
import Dropdown from '../../../../components/dropdown/Dropdown';
import img1 from '../images/appointments.png';
import img2 from '../images/monthlySales.png';
import img3 from '../images/productCards.png';
import img4 from '../images/quickCards.png';
import img5 from '../images/salesByStore.png';
import img6 from '../images/taskList.png';
import img7 from '../images/contactInfo.png';
import img8 from '../images/generalInfo.png';
import img9 from '../images/preferences.png';
import img10 from '../images/customerMini.png';
import CommonService from '../../../../services/CommonService';
import ListPanel from '../../../../components/list-panel/ListPanel';
import DialogModal from '../../../../components/dialog-modal/DialogModal';
import ComponentEditor from '../../component-editor/ComponentEditor';

const RS = new RoutingService();
const connect = new RESTService();
const CS = new CommonService();

class ViewBuilder extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			config: null,
			selectedView: '',
			activeView: null,
			selectedCmp: '',
			toEdit: {},
			toDelete: null,
			unsavedChanges: false,
			expandedCmp: null,
			cmpOpen: false,
			showDeleteModal: false,
			showEditModal: false
		};
		this.autoBind([
			'onViewChange',
			'getViewPanels',
			'onSelectedCmpChange',
			'getCmpImage',
			'addToInterface',
			'onSaveTab',
			'getViewComponents',
			'buildCMPCards',
			'onCmpClick',
			'onEdit',
			'onDelete',
			'moveUp',
			'moveDown',
			'toggleDeleteModal',
			'onConfirmDelete',
			'onCloseEditModal',
			'onSaveComponent',
			'onCompletedChange'
		]);
	}

	onConfirmDelete() {
		let key = this.data.toDelete;
		let cfg = this.data.config;
		let view = cfg.modules.blackbook.views[this.data.selectedView];
		if (view && view.viewComponents[key]) {
			let removing = view.viewComponents[key].order;
			delete view.viewComponents[key];
			let views = Object.values(view.viewComponents);
			if (views.length > 0) {
				for (let i = 0; i < views.length; i++) {
					if (views[i].order > removing) {
						views[i].order--;
					}
				}
			}
			cfg.modules.blackbook.views[this.data.selectedView] = view;
			this.data.config = cfg;
			this.data.toDelete = null;
			this.data.showDeleteModal = false;
			this.onSaveTab();
		}
	}

	toggleDeleteModal() {
		this.setData('showDeleteModal', !this.data.showDeleteModal);
	}

	onDelete(evt) {
		let key = evt.currentTarget.dataset.key;
		if (key) {
			this.observe(() => {
				this.data.showDeleteModal = true;
				this.data.toDelete = key;
			});
		}
	}

	onSaveTab() {
		let path = `modules.blackbook.views.${this.data.selectedView}`;
		let current = this.data.config.modules.blackbook.views[this.data.selectedView];
		if (current) {
			connect
				.updateAppConfigSegment(path, current)
				.then(res => {
					RS.setCurrentConfiguration(res.data);
					RS.showSuccess();
					this.setData('config', res.data);
				})
				.catch(err => {
					console.log(err.response.data);
				});
		}
	}

	onCompletedChange(config) {
		this.setData('config', config);
	}

	componentDidMount() {
		let config = RS.getCurrentConfiguration();
		connect
			.getAppConfig({
				_id: config._id,
				name: config.name,
				version: config.version
			})
			.then(res => {
				RS.setCurrentConfiguration(res.data);
				this.observe(() => {
					this.data.config = res.data;
					let bb = res.data.modules.blackbook;
					let views = Object.values(bb.views);
					if (views.length > 0) {
						this.data.selectedView = views[1].name;
						this.data.activeView = views[1];
						let aCmps = views[1].availableComponents;
						if (aCmps && aCmps.length > 0) {
							this.data.selectedCmp = aCmps[0];
						}
					}
				});
			})
			.catch(err => {
				//TODO's use the new error object
				console.log(err.data);
			});
	}

	onViewChange(val) {
		this.observe(() => {
			this.data.selectedView = val.value;
			this.data.activeView = this.data.config.modules.blackbook.views[val.value];
			this.data.selectedCmp = this.data.config.modules.blackbook.views[val.value].availableComponents[0];
		});
	}

	onSelectedCmpChange(val) {
		this.observe(() => {
			this.data.selectedCmp = val.value;
		});
	}

	addToInterface() {
		let cfg = this.data.config;
		let cmp = cfg.UIComponents[this.data.selectedCmp];
		let view = cfg.modules.blackbook.views[this.data.selectedView];
		if (cmp && view) {
			let newCmp = JSON.parse(JSON.stringify(cmp));
			newCmp.key = CS.UUID();
			newCmp.order = Object.keys(view.viewComponents).length + 1;
			cfg.modules.blackbook.views[this.data.selectedView].viewComponents[newCmp.key] = newCmp;
			this.data.config = cfg;
			this.onSaveTab();
		}
	}

	getViewPanels() {
		let views = [];
		let existing = this.data.config ? this.data.config.modules.blackbook.views : {};
		let vals = Object.values(existing);
		vals.forEach(view => {
			views.push({
				label: view.name,
				value: view.name
			});
		});
		return views;
	}

	getAvailableComponents() {
		let cmps = [];
		if (this.data.config) {
			if (this.data.activeView) {
				let aCmps = this.data.activeView.availableComponents;
				aCmps.forEach(available => {
					cmps.push({
						label: available,
						value: available
					});
				});
			}
		}
		return cmps;
	}

	getCmpImage(cmp) {
		switch (cmp) {
			case 'appointments': {
				return img1;
			}
			case 'salesByStore': {
				return img5;
			}
			case 'quickCards': {
				return img4;
			}
			case 'salesMetrics': {
				return img2;
			}
			case 'tasks': {
				return img6;
			}
			case 'products': {
				return img3;
			}
			case 'General Info': {
				return img8;
			}
			case 'Preferences': {
				return img9;
			}
			case 'Contact Info': {
				return img7;
			}
			case 'Customer Mini Card': {
				return img10;
			}
			default: {
				return img10;
			}
		}
	}

	getViewComponents() {
		if (this.data.config && this.data.selectedView.length > 0) {
			let cmps = this.data.config.modules.blackbook.views[this.data.selectedView].viewComponents;
			if (cmps) {
				return Object.values(cmps);
			}
		}
		return [];
	}

	onCloseEditModal() {
		this.setData('showEditModal', false);
	}

	onSaveComponent(cmp) {
		let path = `modules.blackbook.views.${this.data.selectedView}.viewComponents.${cmp.key}`;
		return connect.updateAppConfigSegment(path, cmp);
	}

	onEdit(evt) {
		let key = evt.currentTarget.dataset.key;
		if (key) {
			this.observe(() => {
				this.data.showEditModal = true;
				this.data.toEdit = this.data.config.modules.blackbook.views[this.data.selectedView].viewComponents[key];
			});
		}
	}

	reorder = (key, up) => {
		let cfg = this.data.config;
		let view = cfg.modules.blackbook.views[this.data.selectedView];
		if (view && view.viewComponents[key]) {
			let moving = view.viewComponents[key].order;
			let viewComponents = Object.values(view.viewComponents);
			for (let i = 0; i < viewComponents.length; i++) {
				if (up) {
					if (viewComponents[i].order === moving - 1) {
						viewComponents[i].order++;
					}
				} else {
					if (viewComponents[i].order === moving + 1) {
						viewComponents[i].order--;
					}
				}
			}
			if (up) {
				view.viewComponents[key].order--;
			} else {
				view.viewComponents[key].order++;
			}
			cfg.modules.blackbook.views[this.data.selectedView] = view;
			this.data.config = cfg;
			this.onSaveTab();
		}
	};

	moveUp(evt) {
		let key = evt.currentTarget.dataset.key;
		this.reorder(key, true);
	}

	moveDown(evt) {
		let key = evt.currentTarget.dataset.key;
		this.reorder(key, false);
	}

	onCmpClick(evt) {
		if (evt.target.classList.contains('action') || evt.target.classList.contains('mdi')) {
			return;
		}
		let key = evt.currentTarget.dataset.key;
		if (key && this.data.expandedCmp !== key) {
			this.observe(() => {
				this.data.expandedCmp = key;
				this.data.cmpOpen = '';
			});
			setTimeout(() => {
				this.setData('cmpOpen', 'open');
			}, 100);
		} else if (key) {
			this.setData('cmpOpen', 'close');
			setTimeout(() => {
				this.observe(() => {
					this.data.expandedCmp = null;
					this.data.cmpOpen = '';
				});
			}, 200);
		}
	}

	getExpandedCmp(cmp) {
		if (this.data.expandedCmp === cmp.key) {
			return (
				<div className={`cmp-details ${this.data.cmpOpen}`} key={'details-key-' + cmp.key}>
					<div className="component-body vbox center vcenter">
						<pre>{JSON.stringify(cmp, undefined, 2)}</pre>
					</div>
				</div>
			);
		}
		return '';
	}

	buildCMPCards() {
		let cmps = [];
		let widgets = this.getViewComponents();
		let expanded = this.data.expandedCmp;
		widgets.sort(function(a, b) {
			return a.order - b.order;
		});
		for (let i = 0; i < widgets.length; i++) {
			let cmp = widgets[i];
			cmps.push([
				<div
					className="dashboard-component-card list-item animated fadeInRight hbox vcenter"
					key={cmp.key}
					data-key={cmp.key}
					onClick={this.onCmpClick}
				>
					{widgets.length > 1 && (
						<div className="vbox vcenter hcenter order-options">
							{cmp.order !== 1 ? (
								<i className="mdi mdi-arrow-up-bold-circle-outline" title="Move Up" data-key={cmp.key} onClick={this.moveUp} />
							) : (
								<div className="spacer" />
							)}
							{cmp.order !== widgets.length && (
								<i className="mdi mdi-arrow-down-bold-circle-outline" title="Move Down" data-key={cmp.key} onClick={this.moveDown} />
							)}
						</div>
					)}
					<img src={this.getCmpImage(cmp.name)} className="list-img" alt="Component" />
					<div className="name ellipse hbox vcenter grow-1">
						{cmp.name}
						<div className="key-line ellipse" title={cmp.key}>
							key:{cmp.key}
						</div>
					</div>
					<div className="grow-1" />
					<div className="grow-1" />
					<div className="actions hbox vcenter grow-1">
						<div className="action vbox hcenter vcenter" data-rh="Configure" data-rh-at="top" data-key={cmp.key} onClick={this.onEdit}>
							<i className="mdi mdi-wrench" data-key={cmp.key} />
						</div>
						<div className="action vbox hcenter vcenter" data-rh="Delete" data-rh-at="top" data-key={cmp.key} onClick={this.onDelete}>
							<i className="mdi mdi-delete" data-key={cmp.key} />
						</div>
						<i className={`mdi mdi-chevron-${expanded && expanded === cmp.key ? 'up' : 'down'}`} />
					</div>
				</div>,
				this.getExpandedCmp(cmp)
			]);
		}
		if (cmps.length <= 0) {
			cmps.push(
				<div className="empty-list" key={'empty-text-1'}>
					There are no components inside of this view.
				</div>
			);
		}
		return cmps;
	}

	render() {
		let { selectedView, selectedCmp, config, unsavedChanges, showDeleteModal, showEditModal, toEdit, activeView } = this.data;
		return (
			<div className={`dashboard-builder-view hbox animated fadeIn ${showEditModal ? 'blur' : ''}`}>
				<div className="options-container panel">
					<div className="active-tab-ctn hbox vcenter">
						<Dropdown
							className="active-tab-picker"
							label="Select a View to Configure"
							value={selectedView}
							handleChange={this.onViewChange}
							name="selectedView"
							options={this.getViewPanels()}
						/>
					</div>
					<div className="components-picker-ctn hbox vcenter">
						<Dropdown
							className="component-picker"
							label="Available UI Components"
							value={selectedCmp}
							handleChange={this.onSelectedCmpChange}
							name="avaliable-component"
							options={this.getAvailableComponents()}
						/>
						<button className="btn primary square vbox hcenter vcenter" data-rh="Add to Interface" data-rh-at="top" onClick={this.addToInterface}>
							<i className="mdi mdi-arrow-right" />
						</button>
					</div>
					{activeView &&
						activeView.availableComponents.length > 0 && (
							<div className="component-image vbox hcenter vcenter shadow grow-1">
								<img
									className={`cmp-img animated flipInX ${selectedCmp}`}
									src={this.getCmpImage(selectedCmp)}
									key={selectedCmp + 'img-key'}
									alt="Component"
								/>
							</div>
						)}
				</div>
				{config && (
					<div className="component-configuration-ctn panel animated fadeIn">
						<ListPanel
							name={`${config.modules.blackbook.views[selectedView].name} View Components`}
							className="component-list-view"
							labels={['Active Components', '', '', 'actions']}
							listItems={this.buildCMPCards()}
							headerItems={<button className={`btn primary small m-r-10 animated zoomIn ${!unsavedChanges ? 'hidden' : ''}`}>Save</button>}
						/>
						<DialogModal
							isOpen={showDeleteModal}
							type="warning"
							showCancelButton={true}
							cancelBtnText="Cancel"
							confirmBtnText="Delete"
							text="Deleting a component cannot be undone"
							title="Are you sure?"
							onConfirm={this.onConfirmDelete}
							onCancel={this.toggleDeleteModal}
						/>
						<ComponentEditor
							isOpen={showEditModal}
							toEdit={toEdit}
							onSave={this.onSaveComponent}
							onClose={this.onCloseEditModal}
							onCompleted={this.onCompletedChange}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default ViewBuilder;



// WEBPACK FOOTER //
// ./src/views/app-composer/concierge/view-builder/ViewBuilder.js